import { Box, Container } from "@mui/material";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import { Typography } from "@platform/design-system";

export interface AIAutoCountProps {
  count: number;
  total: number;
}

export const AIAutoCount = ({
  count,
  total,
}: AIAutoCountProps): React.JSX.Element => (
  <Box
    sx={{
      borderBottom: 1,
      borderColor: "divider",
      width: "100vw",
      mx: "calc(50% - 50vw)",
      py: 1,
    }}
  >
    <Container>
      <Box display="flex" alignItems="center" gap={1}>
        <AutoAwesomeOutlinedIcon sx={{ fontSize: 16 }} />

        <Typography variant="body-large">
          <strong>AI Auto-Populated Items</strong>
        </Typography>

        <Typography variant="body-medium" color="textSecondary">
          ({count}/{total} items)
        </Typography>
      </Box>
    </Container>
  </Box>
);
